(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
    const drawer = document.querySelector('[data-drawer="cart"]');
    if (!drawer) return;
    const API = window.LumeoCartAPI;
    if (!API || !window.LumeoCart) return;
    let cfg = {};
    try { cfg = JSON.parse(drawer.querySelector('[data-cart-config]').textContent); } catch (e) {}
    const strings = { remaining: cfg.remaining || '', reached: cfg.reached || '' };

    function renderBar(cart) {
      const bar = drawer.querySelector('[data-cart-bar]');
      if (!bar) return;
      const threshold = Number(drawer.dataset.threshold || 0);
      const label = drawer.querySelector('[data-cart-bar-label]');
      const fill = drawer.querySelector('[data-cart-bar-fill]');
      const pct = Math.min(100, (cart.total_price / threshold) * 100);
      fill.style.width = pct + '%';
      if (cart.total_price >= threshold) {
        label.textContent = strings.reached;
      } else {
        label.textContent = strings.remaining.replace('__AMT__', API.money(threshold - cart.total_price));
      }
    }

    const T = {
      empty: cfg.empty || '',
      emptyCta: cfg.emptyCta || '',
      remove: cfg.remove || '',
      quantity: cfg.quantity || '',
      decrease: cfg.decrease || '',
      increase: cfg.increase || ''
    };
    const root = window.shopUrls.root;

    function esc(s) { const d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    function itemMarkup(line) {
      const img = line.image
        ? '<img src="' + line.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" loading="lazy" alt="' + esc(line.product_title) + '">'
        : '';
      let opts = '';
      if (line.variant_title && line.variant_title.indexOf('Default') === -1) opts += '<p class="cart-item__variant">' + esc(line.variant_title) + '</p>';
      Object.keys(line.properties || {}).forEach((k) => {
        if (k.charAt(0) !== '_' && line.properties[k]) opts += '<p class="cart-item__variant">' + esc(k) + ': ' + esc(line.properties[k]) + '</p>';
      });
      return '<li class="cart-item" data-cart-item data-key="' + line.key + '">' +
        '<a href="' + line.url + '" class="cart-item__media media media--square">' + img + '</a>' +
        '<div class="cart-item__details">' +
          '<a href="' + line.url + '" class="cart-item__title">' + esc(line.product_title) + '</a>' + opts +
          '<div class="cart-item__row">' +
            '<div class="qty" data-quantity>' +
              '<button type="button" data-qty-line-step="-1" aria-label="' + T.decrease + '">&minus;</button>' +
              '<input type="text" inputmode="numeric" value="' + line.quantity + '" data-qty-line aria-label="' + T.quantity + '">' +
              '<button type="button" data-qty-line-step="1" aria-label="' + T.increase + '">+</button>' +
            '</div>' +
            '<span class="cart-item__price">' + API.money(line.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-item__remove link-underline" data-cart-remove>' + T.remove + '</button>' +
        '</div></li>';
    }

    function render(cart) {
      const body = drawer.querySelector('[data-cart-body]');
      const inline = drawer.querySelector('[data-cart-count-inline]');
      if (inline) inline.textContent = '(' + cart.item_count + ')';
      const subtotal = drawer.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = API.money(cart.total_price);
      const footer = drawer.querySelector('[data-cart-footer]');
      if (footer) footer.hidden = cart.item_count === 0;
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p>' + T.empty + '</p><a href="' + root + 'collections/all" class="btn btn--primary">' + T.emptyCta + '</a></div>';
      } else {
        body.innerHTML = '<ul class="cart-items" data-cart-items>' + cart.items.map(itemMarkup).join('') + '</ul>';
      }
      renderBar(cart);
    }

    async function mutate(payload, optimisticRemoveEl) {
      if (optimisticRemoveEl) optimisticRemoveEl.style.opacity = '0.4';
      try {
        const cart = await API.changeLine(payload);
        render(cart);
      } catch (err) {
        console.error('[Lumeo] cart drawer update failed', payload, err);
        if (optimisticRemoveEl) optimisticRemoveEl.style.opacity = '';
      }
    }

    drawer.addEventListener('click', (e) => {
      const item = e.target.closest('[data-cart-item]');
      if (!item) return;
      const key = item.dataset.key;
      const input = item.querySelector('[data-qty-line]');
      if (e.target.closest('[data-cart-remove]')) { mutate({ id: key, quantity: 0 }, item); return; }
      const stepBtn = e.target.closest('[data-qty-line-step]');
      if (stepBtn) {
        const next = Math.max(0, (Number(input.value) || 1) + Number(stepBtn.dataset.qtyLineStep));
        mutate({ id: key, quantity: next });
      }
    });

    drawer.addEventListener('change', (e) => {
      const input = e.target.closest('[data-qty-line]');
      if (!input) return;
      const item = input.closest('[data-cart-item]');
      mutate({ id: item.dataset.key, quantity: Math.max(0, Number(input.value) || 0) });
    });

    window.LumeoCart.addEventListener('cart:updated', (e) => render(e.detail));
    API.fetchCart().then(render).catch(() => {});
    }

    if (window.LumeoCartAPI || document.readyState === 'complete') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      const root = document.querySelector('[data-cart-upsell]');
      if (!root) return;
      const API = window.LumeoCartAPI;
      if (!API || !window.LumeoCart) return;

      const track = root.querySelector('[data-upsell-track]');
      const prev = root.querySelector('[data-upsell-prev]');
      const next = root.querySelector('[data-upsell-next]');
      const useRecommendations = root.dataset.mode === 'recommendations';
      const limit = Number(root.dataset.limit) || 6;
      let cards = Array.from(track.querySelectorAll('[data-upsell-card]'));
      let loadedFor = null;

      function step() {
        const card = cards.find((c) => !c.hidden);
        return card ? card.getBoundingClientRect().width + 12 : track.clientWidth;
      }

      function syncArrows() {
        const max = track.scrollWidth - track.clientWidth - 2;
        const scrollable = max > 0;
        prev.disabled = !scrollable || track.scrollLeft <= 2;
        next.disabled = !scrollable || track.scrollLeft >= max;
      }

      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);

      /* Shopify recommendations for the first line in the cart, refetched when it changes */
      async function loadRecommendations(productId) {
        const base = (window.shopUrls && window.shopUrls.productRecommendations) || '/recommendations/products';
        const url = base + '?section_id=cart-recommendations&intent=complementary&limit=' + limit + '&product_id=' + productId;
        const res = await fetch(url);
        if (!res.ok) throw new Error('recommendations responded ' + res.status);
        const html = await res.text();
        const holder = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-upsell-cards]');
        track.innerHTML = holder ? holder.innerHTML : '';
        cards = Array.from(track.querySelectorAll('[data-upsell-card]'));
      }

      /* hide products already in the cart, and the whole block when nothing is left to show */
      function filter(cart) {
        const inCart = new Set((cart.items || []).map((line) => line.product_id));
        cards.forEach((card) => {
          card.hidden = inCart.has(Number(card.dataset.productId));
        });
        root.hidden = cart.item_count === 0 || !cards.some((card) => !card.hidden);
        syncArrows();
      }

      async function sync(cart) {
        if (cart.item_count === 0) {
          root.hidden = true;
          return;
        }
        if (useRecommendations) {
          const seed = cart.items[0].product_id;
          if (seed !== loadedFor) {
            loadedFor = seed;
            try {
              await loadRecommendations(seed);
              track.scrollLeft = 0;
            } catch (err) {
              console.error('[Lumeo] cart upsell recommendations failed', err);
              root.hidden = true;
              return;
            }
          }
        }
        filter(cart);
      }

      root.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-upsell-add]');
        if (!btn || btn.disabled) return;
        btn.disabled = true;
        try {
          await API.addToCart({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] });
          btn.classList.add('is-added');
          btn.textContent = btn.dataset.labelAdded;
        } catch (err) {
          console.error('[Lumeo] cart upsell add failed', err);
          btn.disabled = false;
        }
      });

      window.LumeoCart.addEventListener('cart:updated', (e) => sync(e.detail));
      API.fetchCart().then(sync).catch(() => {});
    }

    if (window.LumeoCartAPI || document.readyState === 'complete') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-newsletter]').forEach((el) => {
      if (el.querySelector('.newsletter-form__message--success')) el.classList.add('is-success');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
